import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import TimeSeriesTrendChartView from './TimeSeriesTrendChartView'
import TimeSeriesTrendChartFromInvoiceView from './TimeSeriesTrendChartFromInvoiceView'

const TimeSeriesTrendChartReport = () => {
    const dataMode = localStorage.getItem("dataMode");
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Time Series Trend" mainTitle="Time Series Trend" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                {dataMode === "invoicewise" ? <TimeSeriesTrendChartFromInvoiceView /> : <TimeSeriesTrendChartView />}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default TimeSeriesTrendChartReport
